import type { Resident, ResidentLinks } from '@/types';

import styles from './ArtistLinks.module.css';

interface ArtistLinksProps {
  artist: Resident;
}

const LINK_LABELS: { key: keyof ResidentLinks; label: string }[] = [
  { key: 'soundcloud', label: 'SOUNDCLOUD' },
  { key: 'instagram', label: 'INSTAGRAM' },
  { key: 'ra', label: 'RESIDENT ADVISOR' },
  { key: 'facebook', label: 'FACEBOOK' },
  { key: 'bandcamp', label: 'BANDCAMP' },
];

export default function ArtistLinks({ artist }: ArtistLinksProps) {
  const entries = LINK_LABELS.flatMap((row) => {
    const href = artist.links[row.key];
    return href ? [{ ...row, href }] : [];
  });

  if (entries.length === 0) return null;

  return (
    <section className={styles.section}>
      <header className={styles.head}>
        <span className={styles.num}>/ 03</span>
        <span className={styles.ttl}>LINKS</span>
        <span className={styles.meta}>{entries.length} EXTERNAL · VERIFIED</span>
      </header>
      <div className={styles.list}>
        {entries.map((entry) => (
          <a
            key={entry.key}
            href={entry.href}
            target="_blank"
            rel="noreferrer"
          >
            <span>{entry.label}</span>
            <span className={styles.arrow}>→</span>
          </a>
        ))}
      </div>
    </section>
  );
}
